var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.46941V6.59995C14 7.16 14 7.44003 14.109 7.65394C14.2049 7.8421 14.3578 7.99508 14.546 8.09096C14.7599 8.19995 15.0399 8.19995 15.6 8.19995H19.7305M20 10.1882V17.4C20 19.0801 20 19.9202 19.673 20.5619C19.3854 21.1264 18.9265 21.5854 18.362 21.873C17.7202 22.2 16.8802 22.2 15.2 22.2H8.8C7.11984 22.2 6.27976 22.2 5.63803 21.873C5.07354 21.5854 4.6146 21.1264 4.32698 20.5619C4 19.9202 4 19.0801 4 17.4V6.99995C4 5.31979 4 4.47971 4.32698 3.83798C4.6146 3.27349 5.07354 2.81455 5.63803 2.52693C6.27976 2.19995 7.11984 2.19995 8.8 2.19995H12.0118C12.7455 2.19995 13.1124 2.19995 13.4577 2.28284C13.7638 2.35633 14.0564 2.47754 14.3249 2.64203C14.6276 2.82756 14.887 3.08698 15.4059 3.60584L18.5941 6.79406C19.113 7.31292 19.3724 7.57235 19.5579 7.8751C19.7224 8.14351 19.8436 8.43615 19.9171 8.74226C20 9.08752 20 9.4544 20 10.1882Z",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoiceIcon.7ce2ca46ea0b29bf0ed92b7cd75c297a.svg";
export { ForwardRef as ReactComponent };